<script>
  import {currentNav} from "./Stores";
  import {push} from "./EndpointsAndTransforms";
</script>


<main>
  <navItem
    class:active="{$currentNav === 'projects'}"
    on:click="{ () => { push('projects') }}">
    <p>Projects</p>
  </navItem>
  <navItem
    class:active="{$currentNav === 'rates'}"
    on:click="{ () => { push('rates') }}">
    <p>Rates</p>
  </navItem>
  <navItem
    class:active="{$currentNav === 'rants'}"
    on:click="{ () => { push('rants') }}">
    <p>Ideas & Rants</p>
  </navItem>
  <navItem
    class:active="{$currentNav === 'adventures'}"
    on:click="{ () => { push('adventures') }}">
    <p>Adventures</p>
  </navItem>
</main>

<style>
  main {
    width: 100%;
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-evenly;
    padding-top: 8px;
    padding-bottom: 5px;

    tab-index: 0;
  }

  navItem {
    min-width: 90px;
  }

  .active p {
    opacity: 1;
    font-weight: 700;
  }

  p {
    padding-right: 10px;
    padding-left: 10px;
    font-size: 1.2rem;
  }

  @media only screen and (max-width: 600px) {
    p {
      font-size: 1.0rem;
      padding-right: 4px;
      padding-left: 4px;
    }
  }
</style>